/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { QueryClient, QueryKey, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import fetch from '../../client.ts';
import { getReferralsQueryResponseSchema } from '../schemas/getReferralsSchema.ts';
import type { GetReferrals505, GetReferralsQueryResponse } from '../types/GetReferrals.ts';

export const getReferralsSuspenseQueryKey = () => ['USER_BACKEND', { url: '/referrals' }] as const;

export type GetReferralsSuspenseQueryKey = ReturnType<typeof getReferralsSuspenseQueryKey>;

/**
 * {@link /referrals}
 */
export async function getReferralsSuspense(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetReferralsQueryResponse, ResponseErrorConfig<GetReferrals505>, unknown>({
    method: 'GET',
    url: `/referrals`,
    ...requestConfig,
  });
  return getReferralsQueryResponseSchema.parse(res.data);
}

export function getReferralsSuspenseQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getReferralsSuspenseQueryKey();
  return queryOptions<
    GetReferralsQueryResponse,
    ResponseErrorConfig<GetReferrals505>,
    GetReferralsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getReferralsSuspense(config);
    },
  });
}

/**
 * {@link /referrals}
 */
export function useGetReferralsSuspense<
  TData = GetReferralsQueryResponse,
  TQueryKey extends QueryKey = GetReferralsSuspenseQueryKey,
>(
  options: {
    query?: Partial<
      UseSuspenseQueryOptions<GetReferralsQueryResponse, ResponseErrorConfig<GetReferrals505>, TData, TQueryKey>
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getReferralsSuspenseQueryKey();

  const query = useSuspenseQuery(
    {
      ...getReferralsSuspenseQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as UseSuspenseQueryOptions,
    queryClient
  ) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetReferrals505>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
